export const Counters = () => {
    const data = {} as Record<string, number>;
    return {
        increment(name: string) { data[name] = data[name] || 0; data[name]++; },
        decrement(name: string) { data[name] = data[name] || 0; data[name] = Math.max(data[name], 0); },
        get(name: string) { return data[name] || 0 },
        getAll() { return Object.keys(data).reduce((r, c) => ({ ...r, [c]: data[c] }), {} as Record<string, number>) },
        table(title = "") { console.log("Stats for:", title); console.table(this.getAll()) },
    }
}